/** @format */

import { useEffect, useRef, useState } from 'react';
import { CACHE_INVALIDATED } from '../websocket/UserWebSocket';

/**
 * Hook to re-render when specified cache models are invalidated via WebSocket.
 * @param models {string[]} Cache model keys to listen for (e.g. ['leads-status', 'users'])
 * @returns {number} Version that increments when any of the models is invalidated
 */
function useCacheInvalidation(models) {
  const [version, setVersion] = useState(0);
  const modelsRef = useRef(models);
  modelsRef.current = models;

  useEffect(() => {
    const handler = (e) => {
      const model = e.detail?.model;
      if (model && modelsRef.current.includes(model)) {
        setVersion((v) => v + 1);
      }
    };
    window.addEventListener(CACHE_INVALIDATED, handler);
    return () => window.removeEventListener(CACHE_INVALIDATED, handler);
  }, []);

  return version;
}

/**
 * Hook used to replace "prevProps" and "prevState" behaviour in class components
 * @param value {any} State or prop value
 * @returns {any} State or prop previous value
 */
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export { useCacheInvalidation, usePrevious };

export default null;
